const ValidateDataService = {
    isEmptyValue: function(value){
        return [null, undefined, ''].includes(value)
    } 
}

export default ValidateDataService